// Settings chosen in the Create Game window, sent once the host's socket is
// open (the REST create call only takes the name and password).
import type { LobbySettingsPatch } from "@wp/shared";

const pending = new Map<string, LobbySettingsPatch>();

export function setPendingSettings(lobbyId: string, patch: LobbySettingsPatch): void {
  if (Object.keys(patch).length > 0) pending.set(lobbyId, patch);
}

/** Returns the patch once, then forgets it. */
export function takePendingSettings(lobbyId: string): LobbySettingsPatch | null {
  const patch = pending.get(lobbyId) ?? null;
  pending.delete(lobbyId);
  return patch;
}
